import './theme.css';
import type { AgentLogo } from '@/app/lib/stage/StageHeader.tsx';
import type { MessageDescriptor } from 'react-intl';

export interface SiteConfig {
  brandName: string;
  /** Optional logo in a scrolling circle. Clicking sends Start over within this conversation. */
  logo?: AgentLogo;
  /** The assistant's appearance. 'auto' follows the visitor's OS. */
  appearance: 'light' | 'dark' | 'auto';
  /** Omnibox placeholder override. */
  placeholder?: MessageDescriptor;
}

export const SITE_CONFIG: SiteConfig = {
  brandName: 'Aster Skin Studio',
  appearance: 'light',
};
